module.exports = __webpack_public_path__ + "images/icons_v2/location-baseline-filled-e9112513.svg";